import { useEffect, useRef } from 'react';

const useOnce = (condition: unknown, f: () => void) => {
  const hasRun = useRef(false);
  useEffect(() => {
    if (condition && !hasRun.current) {
      hasRun.current = true;
      f();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- only run when condition changes
  }, [condition]);
};

export default useOnce;
